// extracted by mini-css-extract-plugin
export default {"payPalModeSection":"x7-z"};